export default function Pricing() {
  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <img src="/logo.png" alt="EduAt10" style={logoStyle} />

          <h1>EduAt10 Pricing</h1>

          {/* English Section */}

          <h3>English</h3>

          <p>
            EduAt10 provides affordable digital learning for students. Our
            pricing system is simple and flexible so that students can choose
            subjects according to their needs.
          </p>

          <h2>Monthly Plan</h2>

          <ul>
            <li>Price: <b>INR 10 per subject per month</b></li>
            <li>
              Special Offer: Select <b>5 subjects</b> together and get{" "}
              <b>1 subject FREE</b>
            </li>
          </ul>

          <p>
            Example: If you select 5 subjects, you only pay for 4 subjects.
          </p>

          <h2>Yearly Plan</h2>

          <ul>
            <li>Price: <b>INR 100 per subject per year</b></li>
            <li>
              Special Offer: Select <b>5 subjects</b> together and get{" "}
              <b>1 subject FREE</b>
            </li>
          </ul>

          <p>
            Example: If you select 5 subjects, you only pay for 4 subjects.
          </p>

          <h2>What You Get in EduAt10</h2>

          <ul>
            <li>Study Content Notes</li>
            <li>One Liner Question & Answer</li>
            <li>MCQs Practice Set</li>
            <li>Case Study Based MCQs Practice Set</li>
          </ul>

          <h2>Scholarship Exams</h2>

          <p>
            EduAt10 organizes scholarship exams from time to time where
            students can participate and test their knowledge.
          </p>

          <p>
            Exam Fee: <b>INR 10 to INR 50</b> depending on how many subjects are
            included in the exam.
          </p>

          <hr style={{ margin: "30px 0" }} />

          {/* Hindi Section */}

          <h3>हिंदी</h3>

          <p>
            EduAt10 छात्रों के लिए एक सस्ती और सरल डिजिटल लर्निंग प्लेटफॉर्म
            प्रदान करता है। यहां छात्र अपनी आवश्यकता के अनुसार विषय चुनकर पढ़
            सकते हैं।
          </p>

          <h2>मासिक योजना (Monthly Plan)</h2>

          <ul>
            <li>कीमत: <b>₹10 प्रति विषय प्रति माह</b></li>
            <li>
              विशेष ऑफर: यदि आप <b>5 विषय</b> चुनते हैं तो <b>1 विषय FREE</b>
              मिलेगा।
            </li>
          </ul>

          <p>
            उदाहरण: यदि आप 5 विषय चुनते हैं तो आपको केवल 4 विषयों का ही भुगतान
            करना होगा।
          </p>

          <h2>वार्षिक योजना (Yearly Plan)</h2>

          <ul>
            <li>कीमत: <b>₹100 प्रति विषय प्रति वर्ष</b></li>
            <li>
              विशेष ऑफर: यदि आप <b>5 विषय</b> चुनते हैं तो <b>1 विषय FREE</b>
              मिलेगा।
            </li>
          </ul>

          <p>
            उदाहरण: यदि आप 5 विषय चुनते हैं तो आपको केवल 4 विषयों का ही भुगतान
            करना होगा।
          </p>

          <h2>EduAt10 में क्या मिलेगा?</h2>

          <ul>
            <li>Study Content Notes</li>
            <li>One Liner Question & Answer</li>
            <li>MCQs Practice Set</li>
            <li>Case Study Based MCQs Practice Set</li>
          </ul>

          <h2>Scholarship Exam</h2>

          <p>
            EduAt10 समय-समय पर Scholarship Exam आयोजित करता है जिसमें छात्र
            भाग लेकर अपनी तैयारी को परख सकते हैं।
          </p>

          <p>
            Exam Fee: <b>₹10 से ₹50</b> तक (यह इस बात पर निर्भर करता है कि
            परीक्षा में कितने विषय शामिल हैं)।
          </p>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.25)",
  padding: 20,
};

const cardStyle = {
  background: "rgba(255,255,255,0.95)",
  maxWidth: 900,
  margin: "auto",
  padding: 30,
  borderRadius: 16,
};

const logoStyle = {
  width: 120,
  display: "block",
  margin: "0 auto 20px",
};
